import { Component, Input } from "@angular/core";
import { IconShareComponent } from "../../../components/svg/icon-share/icon-share.component";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-rrss-buttons",
  standalone: true,
  imports: [CommonModule, IconShareComponent],
  templateUrl: "./rrss-buttons.component.html",
  styleUrl: "./rrss-buttons.component.scss",
})
export class RrssButtonsComponent {
  @Input() text = '';
  @Input() url = '';
  @Input() theme: 'light' | 'dark' | 'default' = 'default';
  @Input() customClass: string = '';
  @Input() sharedIcon: boolean = true;
  rrssVisible = false;

  mostrarRRSS(): void {
    const isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    if (isMobile && navigator.share) {
      navigator.share({
        title: this.text,
        text: this.text,
        url: this.url
      }).catch((error) => console.error('Error sharing', error));
    } else {
      this.rrssVisible = !this.rrssVisible;
    }
  }
}
